import type { AccountEventTicket } from 'restful/accounts';
import { formatEventDate } from 'services/datalayer/utils';
import { PageEventFragment } from 'types/api/dato-operations.types';

export const mapAccountTicketToDataLayer = (
  item: AccountEventTicket,
  event: PageEventFragment,
  idx: number,
) => ({
  itemId: item.id,
  itemName: item.name?.['en'] ?? '',
  itemCategory: event.slug,
  itemCategory2: formatEventDate(event.startDatetime),
  itemBrand: '',
  itemListName: 'Ticket event detail',
  index: idx,
  discount: 0,
  price: 0,
  quantity: 1,
});
